module.exports = __webpack_public_path__ + "static/media/OPS.b99e22ca.png";